import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import css from './SectionSkeleton.module.css';

const SectionSkeleton = props => {
  const { rootClassName, className, height = 400 } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes} style={{ height: `${height}px` }}>
      <div className={css.content}>
        <div className={css.titleSkeleton}></div>
        <div className={css.bodySkeleton}>
          <div className={css.lineSkeleton}></div>
          <div className={css.lineSkeleton}></div>
          <div className={css.lineSkeleton}></div>
          <div className={css.lineSkeleton}></div>
        </div>
      </div>
    </div>
  );
};

SectionSkeleton.defaultProps = {
  rootClassName: null,
  className: null,
  height: 400,
};

SectionSkeleton.propTypes = {
  rootClassName: string,
  className: string,
  height: string,
};

export default SectionSkeleton;
